export class GeoIPLocation {

    ipAddress: string = "";
    city: number = 0;
    latitude: string = "";
    longitude: string = "";

    constructor(){
        
    }
 }